import {
  faSortDown,
  faSortUp,
  faTrash
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useContext, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import ConfirmationModal from '../../../helpers/ConfirmationModal';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import UpdateTreeVigourMonitoringModal from './UpdateTreeVigourMonitoringModal';

const TreeVigourMonitoringTable = ({ selectedBlock }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  const [sortOrder, setSortOrder] = useState('asc'); // 'desc' | 'asc'.

  const columns = [
    {
      title: (
        <>
          Date
          <Button
            variant='link'
            size='sm'
            className='p-0 ml-2'
            onClick={() => {
              if (sortOrder === 'desc') setSortOrder('asc');
              else setSortOrder('desc');
            }}
          >
            {sortOrder === 'desc' ? (
              <FontAwesomeIcon icon={faSortDown} />
            ) : (
              <FontAwesomeIcon icon={faSortUp} />
            )}
          </Button>
        </>
      )
    },
    { title: 'Terminated %' },
    { title: 'Active %' },
    { title: 'None %' },
    { title: 'Shoots Infected %' },
    { title: 'Old Damage #' },
    { title: 'New Damage #' },
    { title: 'Broken Damage #' },
    { title: 'Leaves/shoot' },
    { title: '', style: { width: '10%' } }
  ];

  const data = (selectedBlock.alcm_tree_vigour_monitoring || [])
    .slice()
    .sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    });

  return (
    <Table bordered responsive size='sm'>
      <thead>
        <tr>
          {columns.map((column, i) => {
            return (
              <th
                key={`${column.date}-${i}`}
                style={column.style ? column.style : null}
              >
                {column.title}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td
              colSpan={columns.length}
              className='text-center text-muted py-3'
            >
              No tree vigour monitoring records
            </td>
          </tr>
        ) : (
          data.map((row) => {
            const date = moment(row.date, 'YYYY-MM-DD').format('YYYY/MM/DD');
            const terminatedPercent = row.terminated_percent;
            const activePercent = row.active_percent;
            const nonePercent = row.none_percent;
            const shootsInfectedPercent = row.shoots_infected_percent;
            const oldDamageCount = row.old_damage_count;
            const newDamageCount = row.new_damage_count;
            const brokenDamageCount = row.broken_damage_count;
            const leavesPerShoot = row.leaves_per_shoot;
            return (
              <tr key={row.id}>
                <td>{date}</td>
                <td>{terminatedPercent}</td>
                <td>{activePercent}</td>
                <td>{nonePercent}</td>
                <td>{shootsInfectedPercent}</td>
                <td>{oldDamageCount}</td>
                <td>{newDamageCount}</td>
                <td>{brokenDamageCount}</td>
                <td>{leavesPerShoot}</td>
                <td>
                  <div className='d-flex justify-content-center'>
                    <div className='mr-2'>
                      <UpdateTreeVigourMonitoringModal
                        monitoringBlock={selectedBlock}
                        treeVigourMonitoring={row}
                      />
                    </div>
                    <div>
                      <ConfirmationModal
                        title='Confirm Delete'
                        bodyText='Are you sure you want to delete this tree vigour monitoring record?'
                        confirmAction={() => {
                          return alcmStore
                            .deleteTreeVigourMonitoring(
                              row.id,
                              selectedBlock.id
                            )
                            .then(() => {
                              successToast(
                                'Successfully deleted tree vigour monitoring'
                              );
                            })
                            .catch((error) => {
                              console.error(error);
                              errorToast(
                                'Failed to delete tree vigour monitoring'
                              );
                            });
                        }}
                        showButton={{
                          children: <FontAwesomeIcon icon={faTrash} />,
                          props: {
                            className: 'text-danger',
                            variant: 'link',
                            size: 'sm'
                          }
                        }}
                        confirmButton={{
                          props: { variant: 'danger' }
                        }}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </Table>
  );
};

export default observer(TreeVigourMonitoringTable);

